"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _moreTableData = _interopRequireDefault(require("./moreTableData"));

var _utils = _interopRequireDefault(require("../../../../../../utils"));

var _reactCsv = require("react-csv");

// import { useHistory } from 'react-router';
// import config from "config.json";
// import axios from 'axios';
// const { Option } = Select;
// var allTokens = [];
var date = new Date();
var today = "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
var time = "".concat(date.getHours(), ":").concat(date.getMinutes());
var header = [{
  label: "RM_code",
  key: "RM_code"
}, {
  label: "Student_name",
  key: "Student_name"
}, {
  label: "Joining_date",
  key: "Joining_date"
}, {
  label: "status",
  key: "status"
}, {
  label: "WhatsApp_no",
  key: "WhatsApp_no"
}, {
  label: "DOB",
  key: "DOB"
}, {
  label: "School_type",
  key: "school_type"
}, {
  label: "Mathws",
  key: "Worksheet_no"
}, {
  label: "Mathlabel",
  key: "Label"
}, {
  label: "EngWS",
  key: "English_worksheet_no"
}, {
  label: "Englabel",
  key: "English_label"
}, {
  label: "Subject",
  key: "Subject"
}, {
  label: "Mother_name",
  key: "Mother_name"
}, {
  label: "School_fee",
  key: "School_fee"
}, {
  label: "Comment",
  key: "comment"
}, {
  label: "Calling no",
  key: "Calling_no"
}, {
  label: "Class",
  key: "Class"
}, {
  label: "CL code",
  key: "CL_code"
}, {
  label: "Address",
  key: "Address"
}];

var TableData = function TableData(_ref) {
  var data = _ref.data;

  // const history = useHistory();
  // const cl = localStorage.getItem("CL");
  // const token = localStorage.getItem("token");
  // const [apiError, setapiError] = useState(null);
  var _useState = (0, _react.useState)(data),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tableData = _useState2[0],
      setTableData = _useState2[1]; // const [visible, setVisible]= useState(false);


  var csvRport = {
    filename: "\"AllOldRequest Data\" + \" \" + ".concat(today, " + \" \" + ").concat(time),
    headers: header,
    data: data
  }; // useEffect(async () => {
  //   setTableData(data);
  // }, [data]);

  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setTableData(data);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, [data]);
  var tableColumns = [{
    title: "RM Code",
    dataIndex: 'RM_code',
    key: "RM_code",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_code');
    }
  }, {
    title: "Student Name",
    dataIndex: 'Student_name',
    key: 'Student_name',
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Student_name');
    }
  }, {
    title: "Joining Date",
    dataIndex: 'Joining_date',
    key: 'Joining_date',
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Joining_date');
    }
  }, {
    title: 'Status',
    dataIndex: 'actions',
    fixed: "left",
    render: function render(_, record) {
      return /*#__PURE__*/_react.default.createElement(_antd.Tag, {
        color: getStatus(record)
      }, record.status);
    },
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'status');
    }
  }, {
    title: "Whatsapp Number",
    dataIndex: 'WhatsApp_no',
    key: 'WhatsApp_no',
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'WhatsApp_no');
    }
  } // {
  //   title: 'check',
  //   dataIndex: 'RM_code',
  //   fixed: "left",
  //   render: (_, elm) => (
  //     <div>
  //        <Checkbox onClick={()=>getData(elm.Token_no)}/>              
  //     </div>
  //   ),
  // }
  ]; // const getData = (token)=>{
  //   if (allTokens.includes(token)) {
  //     allTokens.splice(allTokens.indexOf(token), 1);
  //   } else {
  //     allTokens.push(token);
  //   }
  //   console.log(allTokens);
  //   if (allTokens.length != 0) {
  //     document.getElementById("edit_bulk").style.display = "block";
  //   } else {
  //     document.getElementById("edit_bulk").style.display = "none";
  //   }
  // }
  // const showModal = () => {
  //   setVisible(true);
  // };
  // const handleOk = () => {
  //   let data = {
  //     "column" : document.getElementById("column_value").value,
  //     "value" : document.getElementById("value").value,
  //     "tokenNo" : allTokens.toString()
  //   }
  //   console.log(data);
  //   let url = config.updateBulkStudent;
  //   axios.post(url, data, { headers: { 'Authorization': token } })
  //     .then(resp => {
  //         if (resp.data.status == "error") setapiError(resp.data);
  //           alert("Updated Successfully");
  //           window.location='/clPortal/app/parent/allparent';
  //     }, err => {
  //         let obj={"status":"error","message":"Network Error"};
  //         if(err.response) setapiError(err.response);
  //         else setapiError(obj);
  //     });
  // };
  // const handleCancel = () => {
  //   setVisible(false);
  // };

  var getStatus = function getStatus(record) {
    if (record.status === 'Rejected' || record.status === 'नहीं') {
      return 'error';
    }

    if (record.status === 'Approved' || record.status === 'हाँ') {
      return 'success';
    }

    return '';
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Old Requests",
    style: {
      'fontSize': '5px'
    },
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, /*#__PURE__*/_react.default.createElement(_antd.Table, {
    columns: tableColumns,
    dataSource: tableData,
    rowKey: "index",
    expandable: {
      expandedRowRender: function expandedRowRender(record) {
        return /*#__PURE__*/_react.default.createElement(_moreTableData.default, {
          tableData: record
        });
      }
    }
  })));
};

var _default = TableData;
exports.default = _default;